import { api } from "@TaankYou/services";


const DownloadBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);  
    }, 100);
};

export const DownloadFile = async (route, filename, data={}, opt = {}, method="GET") => {
    let pro = undefined;

    if(method === "GET")
        pro = api.Get(route, { ...opt, responseType: "blob" });
    else if(method === "POST")
        pro = api.Post(route, data, { ...opt, responseType: "blob" });
    
    return pro.then(blob => DownloadBlob(blob, filename));
}


// WEBPACK FOOTER //
// ./src/Utils/Files.js